/* src/app/questionario-fgenergia/bloco-revisao/questionario-revisao.component.scss */
.label-resposta {
  padding-left: 15px;
}
.text-resposta {
  margin-left: 15px;
}
.titulo-pergunta {
  font-size: 110%;
  font-weight: 500;
}
.subtitulo-pergunta {
  padding-left: 15px;
  font-size: 90%;
  font-style: italic;
}
.box-pergunta {
  margin-top: 30px;
}
.label-pergunta-grupo {
  padding-left: 5px;
  font-weight: 500;
  font-size: 90%;
}
.box-pergunta-custom {
  margin-left: 15px;
}
.item-resposta {
  margin-left: 30px;
  margin-bottom: 20px;
}
/*# sourceMappingURL=questionario-revisao.component.css.map */
